/**
 * TK (Turkmen) — falls back to RU for any missing key (docs/06 §8).
 *
 * ⚠️ DRAFT TRANSLATIONS. docs/06 §8 records the Turkmen strings — in particular the domain unit
 * labels (пачка / упаковка / палета / фура → gap / guty / palet / ýük ulagy) — as DRAFT, pending
 * the owner's confirmation. They are flagged as such in the seed data too. This file is
 * deliberately a PARTIAL translation: keys not translated here fall back to Russian, which is
 * both correct behaviour and honest about what has not been reviewed yet.
 *
 * Do not "complete" this file by machine-translating the rest. A wrong Turkmen string in a work
 * interface is worse than a Russian one the producer already reads fluently, and the open item
 * is tracked against Merdan (CLAUDE.md, "Known open items").
 */
import type { Translations } from './ru';

// Leaves widen to `string`: a MISSPELLED key is still a compile error, but a translated
// VALUE no longer has to equal the RU literal (ru.ts is `as const`).
type DeepPartial<T> = { [K in keyof T]?: T[K] extends object ? DeepPartial<T[K]> : string };

export const tk: DeepPartial<Translations> = {
  common: {
    appName: 'MOST',
    cabinet: 'Öndüriji kabineti',
    save: 'Ýatda saklamak',
    saving: 'Ýatda saklanýar…',
    saved: 'Ýatda saklandy',
    cancel: 'Ýatyrmak',
    back: 'Yza',
    next: 'Öňe',
    close: 'Ýapmak',
    edit: 'Üýtgetmek',
    delete: 'Pozmak',
    retry: 'Gaýtadan',
    loading: 'Ýüklenýär…',
    yes: 'Hawa',
    no: 'Ýok',
    required: 'Hökmany meýdan',
    error: 'Ýalňyşlyk',
    logout: 'Çykmak',
    language: 'Dil',
  },

  // DRAFT — the canonical terminology table in docs/00 §glossary, pending owner confirmation.
  units: {
    pack: 'gap',
    box: 'guty',
    pallet: 'palet',
    truck: 'ýük ulagy',
    kg: 'kg',
  },

  nav: {
    home: 'Kabinet',
    profile: 'Profil',
    products: 'Harytlar',
    orders: 'Sargytlar',
    notifications: 'Habarnamalar',
  },

  status: {
    draft: 'Taslama',
    active: 'Işjeň',
    archived: 'Arhiwde',
    order: {
      new: 'Täze',
      in_progress: 'Işlenilýär',
      completed: 'Tamamlandy',
      cancelled: 'Ýatyryldy',
    },
  },

  profile: {
    title: 'Profil',
    publicSection: 'Alyjylara görünýär',
    privateSection: 'Diňe MOST görýär',
    brandName: 'Brend',
    country: 'Ýurt',
    phone: 'Telefon',
  },

  products: {
    title: 'Harytlar',
    add: 'Haryt goşmak',
    name: 'Ady',
    category: 'Kategoriýa',
    status: 'Ýagdaýy',
  },

  orders: {
    title: 'Sargytlar',
    number: 'Belgi',
    date: 'Sene',
    status: 'Ýagdaýy',
  },

  notifications: {
    title: 'Habarnamalar',
  },
  chat: {
    title: 'MOST goldaw',
    subtitle: 'Biz elýeterli — harytlar, bahalar, sargytlar',
    open: 'Goldaw çatyny açmak',
    close: 'Çaty ýapmak',
    placeholder: 'Habar ýazyň…',
    send: 'Ibermek',
    attach: 'Faýl goşmak',
    record: 'Ses habaryny ýazga almak',
    stopRecording: 'Ýazgyny duruzmak',
    loadOlder: 'Öňki habarlary görkezmek',
    empty: 'Bize ýazyň — harytlar, bahalar we sargytlar boýunça kömek ederis.',
    sendError: 'Iberip bolmady. Täzeden synanyşyň.',
    call: {
      audio: 'Goldawa audio jaň',
      video: 'Goldawa wideo jaň',
      incoming: 'Goldawdan gelýän jaň',
      outgoing: 'Goldawa jaň edilýär…',
      connecting: 'Baglanyşyk…',
      active: 'Gepleşik dowam edýär',
      endedStatus: 'Jaň tamamlandy',
      accept: 'Jogap bermek',
      decline: 'Ret etmek',
      hangUp: 'Tamamlamak',
      completed: 'Jaň',
      missed: 'Sypdyrylan jaň',
      declined: 'Jaň ret edildi',
      mediaDenied: 'Mikrofona ýa-da kamera rugsat ýok',
      connectionLost: 'Baglanyşyk üzüldi',
      failed: 'Jaňy başladyp bolmady',
    },
  },
};
